<template>
    <v-card style="position: relative; overflow: hidden" outlined rounded="lg">
        <calendar-header v-bind="{ type, value }" v-on="{ input, typeChange }" />
        <v-sheet height="560" style="margin: -1px">
            <v-calendar v-bind="{ type, value, events, categories, dayFormat, showMonthOnFirst: false }" v-on="{ input }" category-show-all> </v-calendar>
        </v-sheet>
    </v-card>
</template>

<script>
import dayjs from "dayjs";

import CalendarHeader from "./calendar-header.vue";

export default {
    components: {
        CalendarHeader,
    },
    props: {
        type: { type: String, default: "month" },
        value: { type: String, default: Date.now().toDate() }, //date
        events: { type: Array, default: () => [] },
        categories: { type: Array, default: () => [] },
    },
    methods: {
        dayFormat({ date }) {
            if (this.type == "week") return dayjs(date).format("M/D");
            else return dayjs(date).get("date");
        },
        input(date) {
            this.$emit("input", date);
        },
        typeChange(type) {
            this.$emit("typeChange", type);
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep .v-calendar-weekly__day:not(.v-outside) + .v-outside {
    border-left: 1px solid #e0e0e0;
}
</style>